var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recipient-pane" },
    [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("div", { staticClass: "card-header" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "hd-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      type: "primary",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.openAdd },
                  },
                  [
                    _c("bi-label", {
                      attrs: {
                        zh: "新增接收人",
                        pt: "Novo Destinatário",
                        inline: "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.rows, size: "mini", border: "" },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { prop: "name", "min-width": "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "cell-main" }, [
                            _vm._v(_vm._s(row.name)),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "接收群名称", pt: "Nome do Grupo" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "220" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "cell-webhook ellipsis",
                              attrs: { title: row.webhookMasked },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(row.webhookMasked || "—") + " "
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              class: [
                                "cfg-tag",
                                row.webhookConfigured ? "cfg-ok" : "cfg-no",
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.webhookConfigured ? "已配置" : "未配置"
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "tag-pt" }, [
                                _vm._v(
                                  "/ " +
                                    _vm._s(
                                      row.webhookConfigured
                                        ? "Configurado"
                                        : "Não configurado"
                                    )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: {
                          zh: "@机器人 Webhook",
                          pt: "@ Webhook do Bot",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            { staticClass: "subs-cell" },
                            [
                              _vm._l(
                                _vm.parseSubs(row.subscribeTypes),
                                function (s) {
                                  return _c(
                                    "span",
                                    {
                                      key: s,
                                      staticClass: "tag",
                                      class: _vm.typeCls(s),
                                    },
                                    [
                                      _vm._v(" " + _vm._s(_vm.typeZh(s))),
                                      _c("span", { staticClass: "tag-pt" }, [
                                        _vm._v(" / " + _vm._s(_vm.typePt(s))),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              !_vm.parseSubs(row.subscribeTypes).length
                                ? _c("span", { staticClass: "cell-empty" }, [
                                    _vm._v(" 全部类型"),
                                    _c("span", { staticClass: "tag-pt" }, [
                                      _vm._v(" / Todos os tipos"),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: {
                          zh: "告警类型订阅",
                          pt: "Assinatura de Tipos de Alerta",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "110", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              class: [
                                "st-tag",
                                row.healthStatus === 1 ? "st-on" : "st-err",
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.healthStatus === 1 ? "正常" : "异常"
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "st-pt" }, [
                                _vm._v(
                                  "/ " +
                                    _vm._s(
                                      row.healthStatus === 1
                                        ? "Normal"
                                        : "Falha"
                                    )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "连通性", pt: "Saúde" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "130" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "cell-time" }, [
                            _vm._v(_vm._s(_vm.fmtTime(row.lastTestTime))),
                          ]),
                          _c("div", { staticClass: "cell-time cell-sub" }, [
                            _vm._v(_vm._s(_vm.fmtTime(row.lastSendTime))),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: {
                          zh: "最近测试 / 发送",
                          pt: "Últ. Teste / Envio",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "80", align: "center", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("toggle-switch", {
                            attrs: {
                              value: row.enable === 1,
                              "on-text": "启用 / Ativado",
                              "off-text": "停用 / Desativado",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleToggle(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "启用", pt: "Ativação" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "200", align: "center", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "act-group" }, [
                            _c(
                              "a",
                              {
                                staticClass: "act-edit",
                                class: { "is-disabled": _vm.isEnabled(row) },
                                attrs: {
                                  title: _vm.isEnabled(row)
                                    ? "启用中不可编辑，请先停用 / Desative antes de editar"
                                    : "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(row)
                                  },
                                },
                              },
                              [
                                _vm._v("编辑"),
                                _c("span", { staticClass: "act-pt" }, [
                                  _vm._v(" / Editar"),
                                ]),
                              ]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "act-del",
                                class: { "is-disabled": _vm.isEnabled(row) },
                                attrs: {
                                  title: _vm.isEnabled(row)
                                    ? "启用中不可删除，请先停用 / Desative antes de excluir"
                                    : "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(row)
                                  },
                                },
                              },
                              [
                                _vm._v("删除"),
                                _c("span", { staticClass: "act-pt" }, [
                                  _vm._v(" / Excluir"),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "操作", pt: "Ações" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "tbl-empty",
                  attrs: { slot: "empty" },
                  slot: "empty",
                },
                [
                  _vm._v(" 暂无接收人，请点击「+ 新增接收人」添加 "),
                  _c("span", { staticClass: "empty-pt" }, [
                    _vm._v(
                      '/ Nenhum destinatário; clique em "+ Novo Destinatário"'
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("recipient-dialog", {
        attrs: {
          visible: _vm.dialogVisible,
          mode: _vm.dialogMode,
          row: _vm.currentRow,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          save: _vm.handleSave,
        },
      }),
      _c("confirm-dialog", {
        attrs: {
          visible: _vm.confirmVisible,
          title: _vm.confirmOpts.title,
          "title-pt": _vm.confirmOpts.titlePt,
          subtitle: _vm.confirmOpts.subtitle,
          desc: _vm.confirmOpts.desc,
          "desc-pt": _vm.confirmOpts.descPt,
          "ok-text": _vm.confirmOpts.okText,
          "ok-text-pt": _vm.confirmOpts.okTextPt,
          kind: _vm.confirmOpts.kind,
        },
        on: {
          "update:visible": function ($event) {
            _vm.confirmVisible = $event
          },
          confirm: _vm.confirmOpts.onOk,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticStyle: { "margin-top": "0" } }, [
      _c("span", [_vm._v("飞书群组接收人")]),
      _c("span", { staticClass: "ch-pt" }, [
        _vm._v("Destinatários de Grupos Feishu"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }